'use strict'

const oneForAllProjects = {
    "nexity-test__12456": { "id": "7rlBuTioFAR4IYSxRUnd0b", "key": "3Ar3lK5itYVOE6HOb036Mj" }, // Staging
    "nexity-0038__35051": { "id": "2Oxns8RSXdvI2egKj8kkAh", "key": "1fmyKduOpNtRZLQTWHCFAZ" }, // Production - Villa Daubigny 
    "nexity-0038__35052": { "id": "6ywhfScuRi6awO0v8X9MGO", "key": "1fmyKduOpNtRZLQTWHCFAZ" }, // Production - Clos du bois
    "nexity-0038__35005": { "id": "49ida9lp7oBMhs2WWWLGNP", "key": "1fmyKduOpNtRZLQTWHCFAZ" }, // Production - Lac en scène
    "nexity-0038__36007": { "id": "4IuTrRYI7MmN4SLAb1N8uG", "key": "1fmyKduOpNtRZLQTWHCFAZ" }, // Production - Tilia
    "nexity-0050__87211": { "id": "6V4ZWg2JwVeH9vKaypVHS8", "key": "76fO9uLJqOWHh89SynC9dk" }, // Production - Marseille
    "nexity-0038__35085": { "id": "3kPxyUoe66A7mRfP2LpyDU", "key": "1fmyKduOpNtRZLQTWHCFAZ" }, // Production - Bezons
    "nexity-0050__21038": { "id": "7FsAfmlq2yJrGfLeMrJhZt", "key": "H8TuKiby0twuxiJyJK9nx" }, // Production - Draguignan
    "nexity-0079_58P_07253": { "id": "y1xJu1SwcNjhJ2vMhYvFo", "key": "H8TuKiby0twuxiJyJK9nx" } // Production - Elne
}

export { oneForAllProjects };


// WEBPACK FOOTER //
// ./src/private/oneForAllProjects.js